<template>
  <div class="mt-3">
    Блок для вставки:
    <pre ref="tableHtmlRef">{{ getHtml() }}</pre>
    <button @click="copyHtml" class="btn btn-sm btn-primary mt-1">
      Скопировать
    </button>
  </div>
</template>

<script setup>
import {ref} from "vue"
import Notify from "@/services/Notify"

const tableHtmlRef = ref(null)

function getHtml() {
  return `<table>
\t<tbody>
\t\t<tr>
\t\t\t<th>
\t\t\t\tЗаголовок 1
\t\t\t</th>
\t\t\t<th>
\t\t\t\tЗаголовок 2
\t\t\t</th>
\t\t\t<th>
\t\t\t\tЗаголовок 3
\t\t\t</th>
\t\t</tr>
\t\t<tr>
\t\t\t<td>
\t\t\t\tТекст 1
\t\t\t</td>
\t\t\t<td>
\t\t\t\tТекст 2
\t\t\t</td>
\t\t\t<td>
\t\t\t\tТекст 3
\t\t\t</td>
\t\t</tr>
\t\t<tr>
\t\t\t<td>
\t\t\t\tТекст 1
\t\t\t</td>
\t\t\t<td>
\t\t\t\tТекст 2
\t\t\t</td>
\t\t\t<td>
\t\t\t\tТекст 3
\t\t\t</td>
\t\t</tr>
\t\t<tr>
\t\t\t<td>
\t\t\t\tТекст 1
\t\t\t</td>
\t\t\t<td>
\t\t\t\tТекст 2
\t\t\t</td>
\t\t\t<td>
\t\t\t\tТекст 3
\t\t\t</td>
\t\t</tr>
\t</tbody>
</table>`
}

function copyHtml() {
  if (!tableHtmlRef.value) {
    return
  }

  navigator.clipboard.writeText(getHtml())
      .then(() => {
        Notify.success("Скопировано")
      })
      .catch(() => {
        Notify.error("Не удалось скопировать")
      })
}
</script>

<style scoped></style>
